$(document).ready(() => {
  $(".dot-hustle__slider-container").slick({
    dots: true,
    variableWidth: true,
    infinite: false,
    arrows: false,
    // prevArrow:
    //   '<div class="slick-arrow slick-prev"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0536 8.43604C14.3019 8.43604 14.54 8.33741 14.7156 8.16185C14.8911 7.98629 14.9897 7.74819 14.9897 7.49991C14.9897 7.25164 14.8911 7.01353 14.7156 6.83797C14.54 6.66242 14.3019 6.56379 14.0536 6.56379L3.2077 6.56379L7.22741 2.54595C7.31445 2.45891 7.38349 2.35559 7.4306 2.24187C7.4777 2.12815 7.50194 2.00626 7.50194 1.88318C7.50194 1.76009 7.4777 1.6382 7.4306 1.52448C7.38349 1.41077 7.31445 1.30744 7.22741 1.2204C7.14038 1.13336 7.03705 1.06432 6.92333 1.01722C6.80961 0.970114 6.68773 0.945871 6.56464 0.945871C6.44155 0.945871 6.31966 0.970115 6.20595 1.01722C6.09223 1.06432 5.9889 1.13336 5.90186 1.2204L0.285125 6.83714C0.197947 6.9241 0.128782 7.0274 0.0815891 7.14113C0.0343965 7.25486 0.0101045 7.37678 0.0101046 7.49991C0.0101046 7.62305 0.0343966 7.74497 0.0815892 7.8587C0.128782 7.97243 0.197947 8.07573 0.285125 8.16269L5.90186 13.7794C5.9889 13.8665 6.09223 13.9355 6.20595 13.9826C6.31967 14.0297 6.44155 14.054 6.56464 14.054C6.68773 14.054 6.80961 14.0297 6.92333 13.9826C7.03705 13.9355 7.14038 13.8665 7.22741 13.7794C7.31445 13.6924 7.38349 13.5891 7.4306 13.4753C7.4777 13.3616 7.50194 13.2397 7.50194 13.1166C7.50194 12.9936 7.4777 12.8717 7.4306 12.758C7.38349 12.6442 7.31445 12.5409 7.22741 12.4539L3.2077 8.43604L14.0536 8.43604Z" fill="black"/></svg></div>',
    // nextArrow:
    //   '<div class="slick-arrow slick-next"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.946377 6.56396C0.698102 6.56396 0.459996 6.66259 0.284438 6.83815C0.108881 7.01371 0.0102539 7.25181 0.0102539 7.50009C0.0102539 7.74836 0.108881 7.98647 0.284438 8.16203C0.459996 8.33758 0.698102 8.43621 0.946377 8.43621H11.7923L7.77259 12.4541C7.68555 12.5411 7.61651 12.6444 7.5694 12.7581C7.5223 12.8719 7.49805 12.9937 7.49805 13.1168C7.49805 13.2399 7.5223 13.3618 7.5694 13.4755C7.61651 13.5892 7.68555 13.6926 7.77259 13.7796C7.85962 13.8666 7.96295 13.9357 8.07667 13.9828C8.19039 14.0299 8.31227 14.0541 8.43536 14.0541C8.55845 14.0541 8.68033 14.0299 8.79405 13.9828C8.90777 13.9357 9.0111 13.8666 9.09814 13.7796L14.7149 8.16286C14.8021 8.07591 14.8712 7.9726 14.9184 7.85887C14.9656 7.74514 14.9899 7.62322 14.9899 7.50009C14.9899 7.37696 14.9656 7.25503 14.9184 7.1413C14.8712 7.02757 14.8021 6.92427 14.7149 6.83731L9.09814 1.22058C9.0111 1.13354 8.90777 1.0645 8.79405 1.01739C8.68033 0.970289 8.55845 0.946045 8.43536 0.946045C8.31227 0.946045 8.19039 0.970289 8.07667 1.01739C7.96295 1.0645 7.85962 1.13354 7.77259 1.22058C7.68555 1.30761 7.61651 1.41094 7.5694 1.52466C7.5223 1.63838 7.49805 1.76026 7.49805 1.88335C7.49805 2.00644 7.5223 2.12832 7.5694 2.24204C7.61651 2.35576 7.68555 2.45909 7.77259 2.54613L11.7923 6.56396H0.946377Z" fill="black"/></svg></div>',
  });
});

$(document).ready(() => {
  $(".dot-hustle__slider-container-2").slick({
    dots: true,
    variableWidth: true,
    infinite: false,
    arrows: false,
    // prevArrow:
    //   '<div class="slick-arrow slick-prev"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0536 8.43604C14.3019 8.43604 14.54 8.33741 14.7156 8.16185C14.8911 7.98629 14.9897 7.74819 14.9897 7.49991C14.9897 7.25164 14.8911 7.01353 14.7156 6.83797C14.54 6.66242 14.3019 6.56379 14.0536 6.56379L3.2077 6.56379L7.22741 2.54595C7.31445 2.45891 7.38349 2.35559 7.4306 2.24187C7.4777 2.12815 7.50194 2.00626 7.50194 1.88318C7.50194 1.76009 7.4777 1.6382 7.4306 1.52448C7.38349 1.41077 7.31445 1.30744 7.22741 1.2204C7.14038 1.13336 7.03705 1.06432 6.92333 1.01722C6.80961 0.970114 6.68773 0.945871 6.56464 0.945871C6.44155 0.945871 6.31966 0.970115 6.20595 1.01722C6.09223 1.06432 5.9889 1.13336 5.90186 1.2204L0.285125 6.83714C0.197947 6.9241 0.128782 7.0274 0.0815891 7.14113C0.0343965 7.25486 0.0101045 7.37678 0.0101046 7.49991C0.0101046 7.62305 0.0343966 7.74497 0.0815892 7.8587C0.128782 7.97243 0.197947 8.07573 0.285125 8.16269L5.90186 13.7794C5.9889 13.8665 6.09223 13.9355 6.20595 13.9826C6.31967 14.0297 6.44155 14.054 6.56464 14.054C6.68773 14.054 6.80961 14.0297 6.92333 13.9826C7.03705 13.9355 7.14038 13.8665 7.22741 13.7794C7.31445 13.6924 7.38349 13.5891 7.4306 13.4753C7.4777 13.3616 7.50194 13.2397 7.50194 13.1166C7.50194 12.9936 7.4777 12.8717 7.4306 12.758C7.38349 12.6442 7.31445 12.5409 7.22741 12.4539L3.2077 8.43604L14.0536 8.43604Z" fill="black"/></svg></div>',
    // nextArrow:
    //   '<div class="slick-arrow slick-next"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.946377 6.56396C0.698102 6.56396 0.459996 6.66259 0.284438 6.83815C0.108881 7.01371 0.0102539 7.25181 0.0102539 7.50009C0.0102539 7.74836 0.108881 7.98647 0.284438 8.16203C0.459996 8.33758 0.698102 8.43621 0.946377 8.43621H11.7923L7.77259 12.4541C7.68555 12.5411 7.61651 12.6444 7.5694 12.7581C7.5223 12.8719 7.49805 12.9937 7.49805 13.1168C7.49805 13.2399 7.5223 13.3618 7.5694 13.4755C7.61651 13.5892 7.68555 13.6926 7.77259 13.7796C7.85962 13.8666 7.96295 13.9357 8.07667 13.9828C8.19039 14.0299 8.31227 14.0541 8.43536 14.0541C8.55845 14.0541 8.68033 14.0299 8.79405 13.9828C8.90777 13.9357 9.0111 13.8666 9.09814 13.7796L14.7149 8.16286C14.8021 8.07591 14.8712 7.9726 14.9184 7.85887C14.9656 7.74514 14.9899 7.62322 14.9899 7.50009C14.9899 7.37696 14.9656 7.25503 14.9184 7.1413C14.8712 7.02757 14.8021 6.92427 14.7149 6.83731L9.09814 1.22058C9.0111 1.13354 8.90777 1.0645 8.79405 1.01739C8.68033 0.970289 8.55845 0.946045 8.43536 0.946045C8.31227 0.946045 8.19039 0.970289 8.07667 1.01739C7.96295 1.0645 7.85962 1.13354 7.77259 1.22058C7.68555 1.30761 7.61651 1.41094 7.5694 1.52466C7.5223 1.63838 7.49805 1.76026 7.49805 1.88335C7.49805 2.00644 7.5223 2.12832 7.5694 2.24204C7.61651 2.35576 7.68555 2.45909 7.77259 2.54613L11.7923 6.56396H0.946377Z" fill="black"/></svg></div>',
  });
});

let oneEmailSent = false;

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

// File input
const fileInput = document.querySelector("#file-input");
const fileInputButton = document.querySelector(".mockup__file-input-btn");
const clickInput = () => {
  fileInput.click();
};

fileInput.addEventListener("change", (e) => {
  if (e.target.files.length) {
    fileInputButton.innerHTML = `<p>File uploaded: <span>${e.target.files[0].name}</span></p>`;
  } else {
    fileInputButton.innerHTML = "Upload Design";
  }
});

// Quantity Radio
const customQtyRadio = document.querySelector("#option-6");
const customQtyInput = document.querySelector(".mockup__custom-qty-input");
const plusBtn = document.querySelector(".qty-change-btn.plus");
const minusBtn = document.querySelector(".qty-change-btn.minus");

customQtyInput.addEventListener("focus", () => {
  customQtyRadio.checked = true;
  customQtyInput.value = customQtyRadio.value;
});

plusBtn.addEventListener("click", () => {
  customQtyRadio.value = Number(customQtyRadio.value) + 1;
  customQtyInput.value = customQtyRadio.value;
});

minusBtn.addEventListener("click", () => {
  if (Number(customQtyRadio.value > 5)) {
    customQtyRadio.value = Number(customQtyRadio.value) - 1;
    customQtyInput.value = customQtyRadio.value;
  }
});

// Color box
const colorBox = document.querySelector(".color-patch");
const colorPicker = document.querySelector("#color-picker-input");
const colorName = document.querySelector(".color-name");
const colorInfo = document.querySelector(".color-info");

colorPicker.addEventListener("input", watchColorPicker, false);

function watchColorPicker(event) {
  colorBox.style.backgroundColor = event.target.value;
  colorName.innerHTML = event.target.value;
  colorName.style.color = "#fff";
  colorInfo.querySelector("svg").style.display = "none";
}

function ValidateEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

// Form phone with dashes, + and () allowed: +1 (123)-456-7890
function ValidatePhone(phone) {
  const phoneRegex = /^[0-9+\-\s()]{10,20}$/; // allows 10-20 chars pre-validation, 20 to allow for +1 (123)-456-7890 etc.
  return phoneRegex.test(phone);
}

// Original numeric-only phone validation
function ValidateNumericPhone(phone) {
  const numericPhoneRegex = /^\d+$/;
  return numericPhoneRegex.test(phone);
}

// Function to "clean" phone number by removing all non-numeric characters
// called before sending to api
function cleanPhoneNumber(phone) {
  return phone.replace(/[^\d]/g, "");
}

// Validation
const companyField = document.querySelector("#company-field");
const firstnameField = document.querySelector("#firstname-field");
const lastnameField = document.querySelector("#lastname-field");
const phoneField = document.querySelector("#phone-field");
const emailField = document.querySelector("#email-field");
const fileField = document.querySelector("#file-input");
const companyError = document.querySelector(".company-error");
const firstnameError = document.querySelector(".firstname-error");
const lastnameError = document.querySelector(".lastname-error");
const phoneError = document.querySelector(".phone-error");
const emailError = document.querySelector(".email-error");
const fileError = document.querySelector(".file-error");

const validateFields = () => {
  let validationStatus = true;

  // company name (optional)
  companyError.classList.remove("show-error");

  // first name
  if (!firstnameField.value.length) {
    validationStatus = false;
    firstnameError.classList.add("show-error");
  } else {
    firstnameError.classList.remove("show-error");
  }

  // last name (required)
  if (!lastnameField.value.length) {
    validationStatus = false;
    lastnameError.classList.add("show-error");
  } else {
    lastnameError.classList.remove("show-error");
  }

  // phone
  // strip extra chars in phone number first
  const cleanedPhone = cleanPhoneNumber(phoneField.value);

  // validate the stripped phone number
  if (!ValidatePhone(phoneField.value) || !ValidateNumericPhone(cleanedPhone)) {
    validationStatus = false;
    phoneError.classList.add("show-error");
  } else {
    phoneError.classList.remove("show-error");
    phoneField.value = cleanedPhone; // update field with stripped num
  }

  // email
  if (!ValidateEmail(emailField.value)) {
    validationStatus = false;
    emailError.classList.add("show-error");
  } else {
    emailError.classList.remove("show-error");
  }

  // file
  if (!fileField.files.length) {
    validationStatus = false;
    fileError.classList.add("show-error");
  } else {
    fileError.classList.remove("show-error");
  }

  return validationStatus;
};

// form submit
const submitError = document.querySelector(".submit-error");
const submitSuccess = document.querySelector(".submit-success");
const notesField = document.querySelector("#notes-field");
const qtyRadios = document.getElementsByName("quantity");
const typeRadios = document.getElementsByName("device-option");
const submitBtn = document.querySelector(".request-button");
const submitText = document.querySelector(".submit-form-text");
const submitLoader = document.querySelector(".submit-form-loader");

const submitForm = async () => {
  const validationRes = validateFields();

  if (validationRes === false) {
    submitSuccess.classList.remove("show-error");
    submitError.classList.add("show-error");
    return false;
  } else {
    submitError.classList.remove("show-error");
  }

  //start loading
  submitText.classList.add("hidden-span");
  submitLoader.classList.remove("hidden-span");
  submitBtn.disabled = true;

  let mockupFormData = new FormData();

  mockupFormData.append("companyName", companyField.value);
  mockupFormData.append("firstName", firstnameField.value);
  mockupFormData.append("lastName", lastnameField.value);
  mockupFormData.append("email", emailField.value);
  mockupFormData.append("color", colorPicker.value);
  mockupFormData.append("note", notesField.value);
  mockupFormData.append("phone", phoneField.value);

  if (params["utm_source"]) {
    mockupFormData.append("utm_source", params["utm_source"]);
  } else {
    mockupFormData.append("utm_source", "");
  }

  if (params["tw_adid"]) {
    mockupFormData.append("tw_adid", params["tw_adid"]);
  } else {
    mockupFormData.append("tw_adid", "");
  }

  if (params["tw_source"]) {
    mockupFormData.append("tw_source", params["tw_source"]);
  } else {
    mockupFormData.append("tw_source", "");
  }

  if (params["page_element"]) {
    mockupFormData.append("page_element", params["page_element"]);
  } else {
    mockupFormData.append("page_element", "");
  }

  //get quantity
  qtyRadios.forEach((radio) => {
    if (radio.checked) {
      if (radio.classList.contains("custom-qty-radio")) {
        mockupFormData.append("quantity", customQtyInput.value);
      } else {
        mockupFormData.append("quantity", radio.value);
      }
    }
  });

  const selectedDevices = [];
  //get type
  typeRadios.forEach((checkbox) => {
    if (checkbox.value === "card" && checkbox.checked) {
      selectedDevices.push("Card");
    } else if (checkbox.value === "classic" && checkbox.checked) {
      selectedDevices.push("Classic");
    } else if (checkbox.value === "thin" && checkbox.checked) {
      selectedDevices.push("Thin2");
    } else if (checkbox.value === "metal" && checkbox.checked) {
      selectedDevices.push("Metal");
    }
  });
  mockupFormData.append("type", selectedDevices);

  gtag("event", "conversion", { send_to: "AW-443246987/9JcnCMj8o70YEIvTrdMB" });

  // upload req to server and get download URLs
  let formElement = document.getElementById("devicesFormElement");
  let form = new FormData(formElement);
  await fetch("https://api.dot.cards/mockup", {
    method: "POST",
    body: form,
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      mockupFormData.append("image", data.downloadURLs[0]);
    })
    .catch((error) => {
      submitError.innerHTML = "Failed to upload image, please try again";
    });

  const usedEmail = emailField.value;

  // send zapier request
  await fetch("https://hooks.zapier.com/hooks/catch/11645452/2hsh6rp/", {
    method: "POST",
    body: mockupFormData,
  })
    .then((response) => response.json())
    .then(async (data) => {
      console.log(data);
      if (data.status === "success") {
        // TriplePixel tracking for custom_mockup_form_submission
        const quantity = customQtyInput.value || qtyRadios[0].value;
        const email = emailField.value;
        const name = `${firstnameField.value} ${lastnameField.value}`;
        const company = companyField.value || "";

        TriplePixel("custom", "custom_mockup_form_submission", {
          quantity: quantity,
          email: email,
          name: name,
          company: company,
        });

        clearForm();
        submitSuccess.classList.add("show-error");

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("status", "custom_submitted");
        const newRelativePathQuery =
          window.location.pathname + "?" + searchParams.toString();

        gtag_report_conversion(newRelativePathQuery, "mockup");
      }
    })
    .catch((error) => {
      submitError.innerHTML = "Faild to submit form, please try again";
    });

  // Remove status parameter before analytics tracking
  const urlObj = new URL(window.location.href);
  urlObj.searchParams.delete("status");
  const newUrl = urlObj.toString();
  window.history.replaceState({}, document.title, newUrl);

  analytics.track("Custom Mockup Submission", {
    email: usedEmail,
  });

  // stop Loading
  submitText.classList.remove("hidden-span");
  submitLoader.classList.add("hidden-span");
  submitBtn.disabled = false;
};

const clearForm = () => {
  companyField.value = null;
  firstnameField.value = null;
  lastnameField.value = null;
  phoneField.value = null;
  emailField.value = null;
  fileField.value = null;
  colorPicker.value = "#ffffff";
  colorBox.style.backgroundColor = colorPicker.value;
  colorName.innerHTML = colorPicker.value;
  notesField.value = null;
  qtyRadios[0].checked = true;
  typeRadios[0].checked = true;
  typeRadios[1].checked = false;
  typeRadios[2].checked = false;
  colorName.style.color = "#666";
  fileInputButton.innerHTML = "Upload Design";
};

const scrollToForm = () => {
  if (window.innerWidth < 768) {
    window.scrollTo({ top: 1960, behavior: "smooth" });
  } else if (window.innerWidth < 1024) {
    window.scrollTo({ top: 1980, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 2230, behavior: "smooth" });
  }

  setTimeout(() => {
    companyField.focus();
  }, 1000);
};

// add email to klaviyo list
emailField.addEventListener("change", () => {
  const firstName = firstnameField.value;
  const lastName = lastnameField.value;
  // check flag
  if (oneEmailSent === false) {
    // check if email is valid
    const isValidEmail = ValidateEmail(emailField.value);
    if (isValidEmail) {
      const listPayload = {
        email: emailField.value,
        listName: "custom-device-inquiry",
        firstName: firstName,
        lastName: lastName,
      };
      // send request to add email to list
      axios
        .post(
          "https://staging.api.dot.cards/klaviyo/subscribe/Y87BcJ",
          listPayload
        )
        .then((res) => {
          // set flag to true
          oneEmailSent = true;
          console.log("Response:", res, listPayload);
        })
        .catch((err) => {
          console.log("error");
        });
    }
  }
});
